import { create } from 'zustand';

const useSidebar = create((set) => ({
  topSidebar: 0,
  setTopSidebar: (topSidebar) => set({ topSidebar: topSidebar })
}));

export default useSidebar;
